var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-body',[_c('img',{staticClass:"img-avatar",attrs:{"src":"img/logo.png","alt":"Moviment Graffitti Logo"}}),_c('p',{staticClass:"m-5"},[_vm._v("\n    Welcome!! Want to register contact support!!\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }